import { render, staticRenderFns } from "./listBottom.vue?vue&type=template&id=45b47357"
import script from "./listBottom.vue?vue&type=script&lang=js"
export * from "./listBottom.vue?vue&type=script&lang=js"
import style0 from "./listBottom.vue?vue&type=style&index=0&id=45b47357&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports